export const MUATAN_PER_WILAYAH_URL = 'dashboard/muatan_per_wilayah'
export const MUATAN_PER_WILAYAH_ERROR = 'MUATAN_PER_WILAYAH_ERROR'
export const MUATAN_PER_WILAYAH_LOADING = 'MUATAN_PER_WILAYAH_LOADING'
export const MUATAN_PER_WILAYAH_SUCCESS = 'MUATAN_PER_WILAYAH_SUCCESS'